// extracted by mini-css-extract-plugin
export default {"eventsGrid":"AuditTrail_eventsGrid__dYxlC","tableHeader":"AuditTrail_tableHeader__sot9c"};